<template>
  <li class="collection-navigation-item new-collection">
    <div class="collection-item">
      <span class="icon icon-nav-item">
        <i
          class="mdi mdi-close icon-cancel"
          @click="cancelRenameCollection" />
      </span>
      <input
        class="collection-item-input"
        type="text"
        v-model="newCollectionName"
        ref="renameCollectionInput"
        :placeholder="placeholder"
        @blur="renameCollection"
        @keyup.esc="cancelRenameCollection"
        @keyup.enter="renameCollection" />
    </div>
  </li>
</template>

<script>
export default {
  name: 'RenameCollection',
  props: {
    currentName: String,
    id: Number,
  },
  data() {
    return {
      newCollectionName: this.currentName || null,
      placeholder: 'Press [enter] to save',
    };
  },
  methods: {
    cancelRenameCollection() {
      this.$emit('cancel');
      this.resetInput();
    },
    renameCollection() {
      if (this.newCollectionName) {
        this.$emit('rename', this.newCollectionName, this.id);
        this.resetInput();
      }
      else this.cancelRenameCollection();
    },
    resetInput() {
      this.newCollectionName = null;
      this.$refs.renameCollectionInput.blur();
    },
  },
  mounted() {
    this.$refs.renameCollectionInput.select();
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/colors';
@import '~styles/fonts';

.collection-navigation-item {
  position: relative;
  background: inherit;
}
.collection-item {
  flex-grow: 1;
  font-style: italic;
  cursor: default;
  display: flex;
}
.new-collection i {
  cursor: default !important;
  margin-left: 0.5rem;
  opacity: 0.4;
}
.icon-cancel {
  opacity: 1 !important;
}
.collection-item-input {
  background: transparent;
  border: 0;
  outline: none;
  font-family: $headerFont;
  font-style: italic;
  font-weight: 300;
  padding-left: 0.25rem;
  color: $darkgreyText;
}
</style>
